import * as React from 'react'
import { Footer, Input, Menu } from 'components'
import ContactButton from 'components/Button/ContactButton'
import { Button, Hidden, Icon, IconButton } from '@material-ui/core'
import { styled as muiStyled } from '@material-ui/core/styles'
import styled from 'styled-components'
import { compose } from 'recompose'
import withAuthorization from 'components/Session/withAuthorization'
import * as Auth from 'models/Auth'
import getConfig from 'next/config'
import { Router } from 'routes'
import TopScreen from 'components/pages/TopScreen'
import { useTranslation } from 'i18n'
import WebpImg from 'components/Image/WebpImg'

const {
  publicRuntimeConfig: { environment },
} = getConfig()

const Page = ({ client }) => {
  const { t } = useTranslation('root')

  const onLogout = async () => {
    await Auth.signout()
    client.resetStore()
  }

  return (
    <div style={{ backgroundColor: '#FFF' }}>
      <Gradient>
        <Header>
          <HeaderLogoWebpImg
            webpSrc="/static/images/logo_letter.webp"
            imgSrc="/static/images/logo_letter.png"
            imgProps={{ alt: 'utoniq' }}
          />
          <div style={{ flex: '1 1 auto', paddingLeft: 10 }}>
            <Hidden xsDown>
              <Input.SearchBox
                onSearch={word => {
                  word.trim() && Router.pushRoute('search', { word })
                }}
                value={''}
                fullWidth={false}
              />
            </Hidden>
          </div>
          <Hidden smUp>
            <IconButton onClick={() => Router.pushRoute('searchNoWord')}>
              <Icon style={{ color: 'white' }}>search</Icon>
            </IconButton>
          </Hidden>
          <Hidden xsDown>
            <StyledButton
              style={{ marginRight: 20, border: 'none', borderRadius: 0 }}
              onClick={() => Router.pushRoute('artistDashboard')}
            >
              アーティストログイン
            </StyledButton>
            <Menu.Avatar
              white
              onLogout={onLogout}
              renderNoLogin={
                <>
                  <StyledButton
                    style={{ marginRight: 20 }}
                    variant="contained"
                    onClick={() => Router.pushRoute('login')}
                  >
                    {t('login')}
                  </StyledButton>
                  <StyledButton onClick={() => Router.pushRoute('signup')}>
                    {t('signup')}
                  </StyledButton>
                </>
              }
            />
          </Hidden>
          <Hidden smUp>
            <Menu.Avatar white onLogout={onLogout} />
          </Hidden>
        </Header>
        <TopScreen />
      </Gradient>
      <Content>
        <Section>
          <HeaderTitle>ユートニックでできること</HeaderTitle>
          <FeatureGrid>
            <FeatureContent>
              <ImageContent>
                <SubTitleImg
                  src="/static/images/root/membership_icon.svg"
                  alt=""
                />
              </ImageContent>
              <SubTitle>月額制メンバーシップ</SubTitle>
              <FeatureDesc>
                動画、音声ラジオ、先行情報解禁など、メンバーシップ限定の投稿でファンとの距離を縮め安定した収入を得ることができます。メンバーシップとデジタルトークンと連携可能です。
              </FeatureDesc>
              <FeatureUl>
                <FeatureLi>YouTube埋め込み</FeatureLi>
                <FeatureLi>Twitter連携</FeatureLi>
                <FeatureLi>無料会員</FeatureLi>
                <FeatureLi>アプリ内課金</FeatureLi>
                <FeatureLi>コミュニティ機能</FeatureLi>
                <FeatureLi>お知らせ通知</FeatureLi>
              </FeatureUl>
            </FeatureContent>
            <FeatureContent>
              <ImageContent>
                <SubTitleImg src="/static/images/root/cardicon.svg" alt="" />
              </ImageContent>
              <SubTitle>デジタルトークンでコンテンツ販売</SubTitle>
              <FeatureDesc>
                ライブ動画やデモ音源などあらゆるコンテンツを手軽に販売することができます。
                購入者に対してコンテンツのユニークIDを発行。ユニークID
                をもとにコンテンツのアクセス権を付与する形式なので、複製の防止になります。
              </FeatureDesc>
              <FeatureUl>
                <FeatureLi>
                  <FeatureLiImg src="/static/images/root/magazine.svg" alt="" />
                  <FSpan>マガジン</FSpan>
                </FeatureLi>
                <FeatureLi>
                  <FeatureLiImg src="/static/images/root/sound.svg" alt="" />
                  <FSpan>音源</FSpan>
                </FeatureLi>
                <FeatureLi>
                  <FeatureLiImg src="/static/images/root/video.svg" alt="" />
                  <FSpan>動画</FSpan>
                </FeatureLi>
                <FeatureLi>
                  <FeatureLiImg src="/static/images/root/ticket.svg" alt="" />
                  <FSpan>チケット</FSpan>
                </FeatureLi>
              </FeatureUl>
            </FeatureContent>
          </FeatureGrid>
        </Section>
        <GreenBackground>
          <Section>
            <HeaderTitle>
              コンテンツ付きグッズを販売して
              <br />
              オンラインとオフラインをつなげよう
            </HeaderTitle>
            <Description>
              デジタルトークンをQRコード形式でグッズに付与すれば、店頭やイベントなどでコンテンツ付きグッズとして販売することができます。CDやDVDの代わりとして、カードやステッカーにコンテンツを付与できます。販売したグッズのQRコードを読み込むとコンテンツを視聴でき、
              アプリにコレクションされます。
            </Description>
            <ImageContent>
              <DescriptionWebpImg
                webpSrc="/static/images/root/qrcode_figure.webp"
                imgSrc="/static/images/root/qrcode_figure.png"
                imgProps={{ alt: '' }}
              />
            </ImageContent>
          </Section>
        </GreenBackground>
        <Section>
          <HeaderTitle>
            共通アプリ/Webから専用アプリ/Webへ移行も可能！
          </HeaderTitle>
          <Description>
            共通アプリ/Webから気軽に始めてファンが増えてきた段階で専用アプリ/Webに移行することができます。もちろん専用アプリから開始することもできます。
          </Description>
          <ImageContent>
            <DescriptionWebpImg
              webpSrc="/static/images/root/app_icon_group.webp"
              imgSrc="/static/images/root/app_icon_group.png"
              imgProps={{ alt: '' }}
            />
          </ImageContent>
        </Section>
        <GreenBackground>
          <Section>
            <HeaderTitle>その他機能も続々リリース予定！</HeaderTitle>
            <NewFeaturesContent>
              <IconBox>
                <IconImg src="/static/images/root/carticon.svg" alt="" />
              </IconBox>
              <IconBox>
                <IconImg src="/static/images/root/liveicon.svg" alt="" />
              </IconBox>
              <IconBox>
                <IconImg src="/static/images/root/memberscardicon.svg" alt="" />
              </IconBox>
              <IconBox>
                <IconImg src="/static/images/root/missionicon.svg" alt="" />
              </IconBox>
              <IconBox>
                <IconImg src="/static/images/root/integrationicon.svg" alt="" />
              </IconBox>
            </NewFeaturesContent>
          </Section>
        </GreenBackground>
        <Section>
          <HeaderTitle>無料ですべての機能が使えます</HeaderTitle>
          <Description>
            収益から手数料を引いた金額をお振込させていただきます。
          </Description>
          <ImageContent>
            <WebpImg
              webpSrc="/static/images/root/0yen.webp"
              imgSrc="/static/images/root/0yen.png"
              imgProps={{ alt: '' }}
            />
          </ImageContent>
          <ContactArea>
            <ContactButton />
          </ContactArea>
        </Section>
        <GreenBackground>
          <Section>
            <HeaderTitle>様々な分野で利用できます</HeaderTitle>
            <HashUl>
              <HashLi>ミュージシャン</HashLi>
              <HashLi>アイドル</HashLi>
              <HashLi>ダンサー</HashLi>
              <HashLi>インフルエンサー</HashLi>
              <HashLi>タレント</HashLi>
              <HashLi>お笑い芸人</HashLi>
              <HashLi>漫画家</HashLi>
              <HashLi>yoututer</HashLi>
              <HashLi>イラストレーター</HashLi>
              <HashLi>教育</HashLi>
              <HashLi>ジャーナリスト</HashLi>
              <HashLi>ライター</HashLi>
            </HashUl>
          </Section>
        </GreenBackground>
        <Section>
          <HeaderTitle>利用ケース</HeaderTitle>
          <CaseContent>
            <CaseHeader>
              <CaseTitle>LITE</CaseTitle>
              <CaseSubTitle>インストロックバンド</CaseSubTitle>
            </CaseHeader>
            <CaseDesc>
              月額メンバーシップを利用。ファン向けに限定のLIVE配信や音源をデジタルカードで配布。
            </CaseDesc>
            <CaseWebpImg
              webpSrc="/static/images/root/lite.webp"
              imgSrc="/static/images/root/lite.png"
              imgProps={{ alt: 'lite' }}
            />
          </CaseContent>
          <CaseContent reverse>
            <CaseHeader>
              <CaseTitle>はるまきごはん</CaseTitle>
              <CaseSubTitle>ボカロP</CaseSubTitle>
            </CaseHeader>
            <CaseDesc>
              限定の音声や動画を見ることができるコンテンツ付きカードとしてライブ来場者に限定配布。
              サイトに隠しコンテンツとして仕込むなど、多様な方法で世界観をファンに届け話題に
            </CaseDesc>
            <CaseWebpImg
              webpSrc="/static/images/root/harumakigohan.webp"
              imgSrc="/static/images/root/harumakigohan.png"
              imgProps={{ alt: 'harumakigohan' }}
            />
          </CaseContent>
          <CaseContent>
            <CaseHeader>
              <CaseTitle>木梨憲武展 フェアリーズ</CaseTitle>
              <CaseSubTitle>クリエイター</CaseSubTitle>
            </CaseHeader>
            <CaseDesc>
              人気作品をデジタルトークンに落とし込み、グッズ(ステッカー)とアプリを連動する企画を展開。
              30種類のカードそれぞれに限定の動画が付随。
            </CaseDesc>
            <CaseWebpImg
              webpSrc="/static/images/root/fairies.webp"
              imgSrc="/static/images/root/fairies.png"
              imgProps={{ alt: 'fairies' }}
            />
          </CaseContent>
        </Section>
        <Section>
          <ContactAttention>
            アーティスト、クリエイターそれぞれに適した企画や提案が可能です。お気軽にお問い合わせください。
          </ContactAttention>
          <ContactArea>
            <ContactButton />
          </ContactArea>
        </Section>
      </Content>
      <Footer.Info />
    </div>
  )
}

Page.getInitialProps = async ({ req }) => {
  return { namespacesRequired: ['root', 'common', 'components'] }
}

const ComposedPage = compose(withAuthorization(false))(Page)

export default ComposedPage

const CaseContent = styled.div<{ reverse?: boolean }>`
  padding: 40px 10px;
  display: grid;
  column-gap: 20px;
  ${({ reverse, theme }) => `
    grid-template:
      ${
        reverse
          ? `
        "header thumb" max-content
        "desc   thumb";
      `
          : `
        "thumb header" max-content
        "thumb desc";
      `
      }
    ${theme.breakpoints.down('sm')} {
      grid-template: 
        "thumb"
        "header"
        "desc";
    }


    ${reverse && 'background: rgba(196, 196, 196, 0.1);'}
  `}
`

const CaseDesc = styled.div`
  grid-area: desc;
  color: #7b7b7b;
  font-size: 18px;
`

const CaseHeader = styled.header`
  grid-area: header;
`

const CaseWebpImg = styled(WebpImg)`
  place-self: center;
  grid-area: thumb;
  max-width: 100%;
`

const NewFeaturesContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 20px 0;
`

const IconBox = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 28px rgba(0, 0, 0, 0.25);
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
`

const IconImg = styled.img``

const FeatureContent = styled.div`
  flex: 1 1 50%;
`

const Content = styled.div``

const ImageContent = styled.div`
  text-align: center;
`

const HeaderLogoWebpImg = styled(WebpImg)`
  width: 130px;
`

const SubTitleImg = styled.img`
  max-width: 100%;
  height: 90px;
`

const DescriptionWebpImg = styled(WebpImg)`
  max-width: 100%;
`

const HeaderTitle = styled.h2`
  font-size: 22px;
  text-align: center;
  margin: 0.5em auto;
  ${({ theme }) => `
    ${theme.breakpoints.down('sm')} {
      font-size: 22px;
    }
  `}
`
const SubTitle = styled.h3`
  font-size: 18px;
  text-align: center;
  ${({ theme }) => `
    ${theme.breakpoints.down('sm')} {
      font-size: 18px;
    }
  `}
`

const Description = styled.p`
  text-align: center;
  font-size: 18px;
  color: #263238;
  line-height: 27px;
`

const FeatureGrid = styled.div`
  margin-top: 20px;
  justify-content: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 80px;
  grid-row-gap: 70px;
  ${({ theme: { breakpoints: b } }) => `
     ${b.down('sm')} {
       grid-template-columns: 1fr;
     }
  `}
`

const StyledButton = muiStyled(Button)(({ variant }: { variant?: string }) => ({
  color: variant == 'contained' ? 'black' : 'white',
  border: 'white solid 2px',
  borderRadius: 20,
  fontWeight: 600,
}))

const Gradient = styled.div`
  background-image: linear-gradient(
      118.35deg,
      rgba(126, 197, 163, 0.96) 0.39%,
      rgba(41, 106, 197, 0.96) 100.31%,
      rgba(29, 93, 202, 0.96) 100.32%,
      rgba(20, 84, 205, 0.96) 100.33%,
      rgba(55, 56, 160, 0.96) 100.34%,
      rgba(77, 55, 145, 0.96) 100.35%,
      rgba(25, 39, 168, 0.96) 100.36%,
      rgba(23, 50, 168, 0.96) 100.37%,
      rgba(254, 252, 252, 0.015) 100.38%,
      rgba(255, 255, 255, 0) 100.39%,
      rgba(255, 255, 255, 0) 100.39%
    ),
    url('/static/images/root/background.jpg');
  background-size: cover;
  background-position: center;
`

const Section = styled.section`
  max-width: 1080px;
  margin: auto;
  padding: 70px 50px;
  ${({ theme }) => `${theme.breakpoints.up('sm')} {
    padding: 70px 70px;
  }`}
`

const Header = styled.div({
  width: '100%',
  margin: '0',
  padding: '5px 13px',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  zIndex: 1,
})

const HashUl = styled.ul`
  text-align: center;
`

const HashLi = styled.li`
  display: inline-block;
  list-style-type: none;
  font-size: 18px;
  color: #7b7b7b;
  font-weight: 600;
  margin-right: 2em;
  &:before {
    content: '#';
  }

  ${({ theme: { breakpoints: b } }) => `
    ${b.down('sm')} {
      font-size: 18px;
    }
  `}
`

const ContactArea = styled.div`
  text-align: center;
  margin: 30px 0;
`

const GreenBackground = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(126, 197, 163, 0.1);
`
const FeatureUl = styled.ul`
  columns: 2;
  padding-inline-start: 0;
`

const FeatureLi = styled.li`
  list-style-type: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin: 2px 0;
  height: 40px;
`
const FeatureDesc = styled.p`
  font-size: 18px;
  color: #263238;
`

const FeatureLiImg = styled.img`
  width: 25px;
  height: 25px;
`

const CaseTitle = styled.h3`
  font-size: 22px;
  color: #263238;
  font-weight: 600;
  margin: 5px 0;
`

const CaseSubTitle = styled.p`
  margin: 5px 0;
  font-size: 18px;
  color: #7b7b7b;
  font-weight: 600;
`

const FSpan = styled.span`
  padding-left: 10px;
`

const ContactAttention = styled.p`
  font-size: 28px;
  color: #263238;
  font-weight: 600;
  text-align: center;
`
